import React from 'react';
import { FormattedMessage } from 'react-intl';
import Icons from '../../components/Icons/Icons';
import css from './ProfilePage.module.css';

import {
  buildingSystemOptions,
  companyAccrediationsOptions,
  geographicalReachOptions,
} from '../../util/general';
import { getLabelFromKey, isArrayLength } from '../../util/genericHelpers';
import { H4 } from '../../components';

const renderSection = (headingId, keys, options) => {
  if (!isArrayLength(keys)) return null;

  return (
    <>
      <H4 as="h4">
        <FormattedMessage id={headingId} />
      </H4>
      <div className={css.serviceList}>
        {keys.map((key, index) => (
          <div key={index} className={css.service}>
            <Icons name="check" /> {getLabelFromKey(key, options)}
          </div>
        ))}
      </div>
    </>
  );
};

const CompanyProfileSection = ({ publicData = {} }) => {
  const {
    buildingSystemUsed = [],
    companyAccrediations = [],
    geographicalReach = [],
    companyAwards,
  } = publicData;

  return (
    <div className={css.infoBlock}>
      <h2>
        <FormattedMessage id="ProfilePage.companyProfileHeading" />
      </h2>
      {renderSection(
        'ProfilePage.buildingSystemUsed.heading',
        buildingSystemUsed,
        buildingSystemOptions
      )}

      {renderSection(
        'ProfilePage.companyAccrediations.heading',
        companyAccrediations,
        companyAccrediationsOptions
      )}

      {renderSection(
        'ProfilePage.geographicalReach.heading',
        geographicalReach,
        geographicalReachOptions
      )}

      {companyAwards && (
        <>
          <H4 as="h4">
            <FormattedMessage id="ProfilePage.companyAwards.heading" />
          </H4>
          <div className={css.serviceList}>
            <div className={css.service}>
              <Icons name="check" /> {companyAwards}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CompanyProfileSection;
